import React, { useRef, useState } from "react";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { Col, Form, Offcanvas, Row } from "react-bootstrap";
import Select, { SingleValue } from "react-select";
import DesviacionService from "../../../services/DesviacionService";
import { ITipoCausaBasica } from "../../../entities/ITipoCausaBasica";
import { IFactoresPersonales } from "../../../entities/IFactoresPersonales";
import { ICapacidades } from "../../../entities/ICapacidades";
import ISearch from "../../../entities/helper/ISearch";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../../helpers/variableHelper";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import UserPicker from "../../../controls/UserPicker";
import moment from "moment";
import IUserPickerValue from "../../../entities/helper/IUserPickerValue";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import { IAddCausaBasica, ICausaBasica } from "../../../entities/ICausaBasica";
import { dateFormatDiplay, dateFormatInputReference } from "../../../helpers/dateHelper";
import { E_EstadoCausa } from "../../../enums/E_EstadoCausa";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import IDocumentoDesviacion, { ISearchDocsCausasEvidencias } from "../../../entities/IDocumentoDesviacion";
import { getFileName } from "../../../helpers/pathHelper";
import { ICausa } from "../../../entities/IDesviacion";
import { ModalCausaObservaciones, ModalCausaRechazo, ModalConfirmacionCierre } from "./Modal/ModalCausaObservaciones";
import { E_EstadoFormCausaDesviacion } from "../../../enums/E_EstadoFormulario";
import Loading from "../../../cross/Loading";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import IAuditoria from "../../../entities/IAuditoria";

interface IAgregarAnalisisCausalProps {
  token: string;
  idDesviacion: number;
  onClose: () => void;
  onSave: () => void;
  selectedAnalisisCausalAC?: ICausaBasica | null;
  estadoForm: E_EstadoFormCausaDesviacion;
  isVistaDetallada?: boolean;
  responsable?: string;
  responsableCierre?: string;
  items?: Array<IDocumentoDesviacion>;
  loading?: boolean;
  is_test?: boolean;
  addDesviacion?: IAddCausaBasica;
  listTCB?: Array<ITipoCausaBasica>;
  selectedAudit: IAuditoria | null;
}
export default function AgregarAnalisisCausalBasica({
  // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 40 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  token,
  idDesviacion,
  onClose,
  onSave,
  selectedAnalisisCausalAC,
  estadoForm,
  isVistaDetallada,
  responsable,
  responsableCierre,
  items,
  loading,
  is_test,
  listTCB,
  addDesviacion,
  selectedAudit,
}: IAgregarAnalisisCausalProps) {
  const [comboTCB, setComboTCB] = useState<Array<ITipoCausaBasica>>(listTCB ?? []);
  const [comboFP, setComboFP] = useState<Array<IFactoresPersonales>>([]);
  const [comboDC, setComboDC] = useState<Array<ICapacidades>>([]);
  const totalPagesListDocumentos = useRef<number>(0);
  const [isLoading, setIsLoading] = useState(loading ?? true);
  const [valComboCB, setValComboCB] = useState<IComboboxOption | null>(
    selectedAnalisisCausalAC
      ? {
          label: selectedAnalisisCausalAC?.TIPO_CAUSA_BASICA,
          value: selectedAnalisisCausalAC?.ID_TIPO_CAUSA_BASICA.toString(),
        }
      : null
  );
  const [valComboFP, setvalComboFP] = useState<IComboboxOption | null>(
    selectedAnalisisCausalAC
      ? {
          label: selectedAnalisisCausalAC?.FACTORES_PERSONALES,
          value: selectedAnalisisCausalAC?.ID_FACTORES_PERSONALES.toString(),
        }
      : null
  );
  const [valComboDC, setvalComboDC] = useState<IComboboxOption | null>(
    selectedAnalisisCausalAC
      ? {
          label: selectedAnalisisCausalAC?.CAPACIDADES,
          value: selectedAnalisisCausalAC?.ID_CAPACIDADES.toString(),
        }
      : null
  );
  const refTxtAccion = React.createRef<HTMLTextAreaElement>();
  const [lenAccion, setLenAccion] = useState(0);
  const [valResponsable, setValResponsable] = useState<IUserPickerValue | null>(
    selectedAnalisisCausalAC
      ? {
          mail: selectedAnalisisCausalAC?.RESPONSABLE,
          name: selectedAnalisisCausalAC?.RESPONSABLE_DISPLAY,
        }
      : null
  );
  const refTxtFechaHasta = React.createRef<HTMLInputElement>();
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [arrErrors, setArrErrors] = useState<string[]>([]);
  const [listDocumentos, setListDocumentos] = useState<Array<IDocumentoDesviacion>>(items || []);
  const [isSendingData, setIsSendingData] = useState(false);
  console.log(isLoading);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (info: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          DesviacionService.getContenidoDocumentoAnalisCausal(token, info.row.original.URL);
        }}></i>
    );
  };

  const renderEstadoForm = () => {
    if (
      (responsableCierre && responsableCierre !== null) ||
      (selectedAudit?.AUDITORES_ACOMPANANTES && selectedAudit?.AUDITORES_ACOMPANANTES !== null)
    ) {
      return responsableCierre === currentUser?.email || isParticipatingAudit(selectedAudit?.AUDITORES_ACOMPANANTES, currentUser?.email);
    } else {
      return responsable === currentUser?.email;
    }
  };

  const isParticipatingAudit = (users: string | undefined, emailUser: string | undefined) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    console.log(selectedAnalisisCausalAC);
    setCurrentUser(currUser);
    await fillComboTCB();
    if (selectedAnalisisCausalAC) {
      await handleCargarDocumentos();
      setLenAccion(selectedAnalisisCausalAC?.ACCION.length || 0);
      console.log("cc");
      await fillComboFP(selectedAnalisisCausalAC.ID_TIPO_CAUSA_BASICA.toString());
      await fillComboDC(selectedAnalisisCausalAC.ID_FACTORES_PERSONALES.toString());
    }
    setIsLoading(false);
  }, []);
  const common: ISearch = {
    ORDENADOPOR: "TITULO",
    ORIENTACION: "ASC",
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
  };

  const fillComboTCB = async () => {
    const resultTCB = is_test ? listTCB ?? [] : await DesviacionService.getListadoTiposCausaBasica(token, { ...common, ACTIVO: true });
    setComboTCB(resultTCB);
    setComboFP([]);
    setComboDC([]);
  };

  const fillComboFP = async (comboCB: string) => {
    const resultFP = await DesviacionService.getListadoFactoresPersonales(token, { ...common, ACTIVO: true, TIPO_FACTOR: comboCB });
    setComboFP(resultFP || []);
    setComboDC([]);
  };

  const fillComboDC = async (comboFP: string) => {
    const resultDC = await DesviacionService.getListadoCapacidades(token, {
      ...common,
      ACTIVO: true,
      ID_FACTOR_PERSONAL: parseInt(comboFP),
    });
    setComboDC(resultDC || []);
  };

  const validateForm = (value: IAddCausaBasica) => {
    let errors = [];
    if (!value.ID_TIPO_CAUSA_BASICA) {
      errors.push("ID_TIPO_CAUSA_BASICA");
    }
    if (!value.ID_FACTORES_PERSONALES) {
      errors.push("ID_FACTORES_PERSONALES");
    }
    if (!value.ID_CAPACIDADES) {
      errors.push("ID_CAPACIDADES");
    }
    if (!value.ACCION) {
      errors.push("ACCION");
    }
    if (!value.RESPONSABLE) {
      errors.push("RESPONSABLE");
    }
    if (!moment(value.FECHA_HASTA).isValid()) {
      errors.push("FECHA_HASTA");
    }

    setArrErrors(errors);

    return errors.length === 0;
  };

  const handleGuardarCausaBasica = async () => {
    let value: IAddCausaBasica = {
      ID: selectedAnalisisCausalAC?.ID,
      ID_DESVIACION: idDesviacion,
      ID_TIPO_CAUSA_BASICA: parseInt(valComboCB?.value as string),
      ID_FACTORES_PERSONALES: parseInt(valComboFP?.value as string),
      //ID_CAPACIDADES: parseInt(valComboDC?.value as string),
      ID_CAPACIDADES: parseInt(valComboDC?.value as string),
      ID_ESTADO: E_EstadoCausa.Asignada,
      ACCION: refTxtAccion.current?.value as string,
      RESPONSABLE: valResponsable?.mail as string,
      RESPONSABLE_DISPLAY: valResponsable?.name as string,
      FECHA_ASIGNACION: selectedAnalisisCausalAC ? selectedAnalisisCausalAC.FECHA_ASIGNACION : new Date(),
      FECHA_HASTA: new Date(refTxtFechaHasta.current?.value as string),
      DESCRIPCION_TECNICA: null,
      FECHA_MODIFICACION: selectedAnalisisCausalAC ? new Date() : null,
      AUTOR: currentUser?.email as string,
      AUTOR_DISPLAY: currentUser?.fullname as string,
      EDITOR: null,
      EDITOR_DISPLAY: null,
      RECHAZO: null,
      FECHA_CREACION: selectedAnalisisCausalAC ? selectedAnalisisCausalAC.FECHA_CREACION : new Date(),
    };
    if (validateForm(value)) {
      setIsSendingData(true);
      await DesviacionService.postCausaBasica(token, value);
      onSave();
      setIsSendingData(false);
    }
  };

  const handleCerrarCausa = (estado: E_EstadoCausa) => {
    let val: ICausa = {
      ID: selectedAnalisisCausalAC?.ID as number,
      EDITOR: currentUser?.email as string,
      EDITOR_DISPLAY: currentUser?.fullname as string,
      ID_DESVIACION: idDesviacion,
      ID_ESTADO: estado,
      REQUIERE_CAMBIO_ESTADO: true,
      FECHA_ACCION_REALIZADA: selectedAnalisisCausalAC?.FECHA_ACCION_REALIZADA,
      FECHA_INGRESO_ACCION_REALIZADA: selectedAnalisisCausalAC?.FECHA_INGRESO_ACCION_REALIZADA,
    };

    if (estado === E_EstadoCausa.CerradoObservacion) {
      ModalCausaObservaciones(async (observacion: string) => {
        val.CON_OBSERVACION = estado === E_EstadoCausa.CerradoObservacion;
        val.OBSERVACIONES = observacion;
        setIsSendingData(true);
        await DesviacionService.postAccionCierreCausaBasica(token, val);
        onSave();
      });
    } else if (estado === E_EstadoCausa.Cerrado) {
      ModalConfirmacionCierre(async () => {
        setIsSendingData(true);
        await DesviacionService.postAccionCierreCausaBasica(token, val);
        onSave();
      });
    } else if (estado === E_EstadoCausa.Rechazada) {
      ModalCausaRechazo(async (motivoRechazo: string) => {
        val.MOTIVO_RECHAZO = motivoRechazo;
        val.RECHAZO = estado === E_EstadoCausa.Rechazada || null;
        setIsSendingData(true);
        await DesviacionService.postAccionCierreCausaBasica(token, val);
        onSave();
      });
    }
  };
  const handleCargarDocumentos = async (pagination?: IPagination) => {
    let params: ISearchDocsCausasEvidencias = pagination
      ? {
          ...pagination,
          ID_CAUSA: selectedAnalisisCausalAC?.ID,
          ID_DESVIACION: idDesviacion,
        }
      : {
          ID_CAUSA: selectedAnalisisCausalAC?.ID,
          ID_DESVIACION: idDesviacion,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
        };
    let resultDocumentos = is_test ? { data: items ?? [], pages: 10 } : await DesviacionService.getDocumentosCausasEvidencias(token, params);
    setListDocumentos(resultDocumentos.data);
    totalPagesListDocumentos.current = resultDocumentos.pages;
  };
  const columnHelperDocumentos = createColumnHelper<IDocumentoDesviacion>();
  let columnsDefDocumentos = [
    columnHelperDocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  const error = (err: any) => {
    return arrErrors.includes(err) && "error";
  };

  return (
    <Offcanvas show={true} onHide={onClose} placement={"end"} className="w-50 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">Causas Básicas</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <button
                hidden={true}
                data-testid="btnvalidate"
                onClick={() => {
                  if (addDesviacion !== undefined) {
                    validateForm(addDesviacion);
                    handleGuardarCausaBasica();
                    handleCerrarCausa(E_EstadoCausa.CerradoObservacion);
                    handleCerrarCausa(E_EstadoCausa.Cerrado);
                    handleCerrarCausa(E_EstadoCausa.Rechazada);
                    fillComboFP("");
                    fillComboDC("");
                  }
                }}></button>
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Tipo de Causas Básicas:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboTCB.map((vcc) => ({
                      value: vcc.ID.toString(),
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_TIPO_CAUSA_BASICA")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: SingleValue<IComboboxOption>) => {
                      setValComboCB(e || null);
                      fillComboFP(e?.label as string);
                    }}
                    defaultValue={
                      selectedAnalisisCausalAC
                        ? {
                            value: selectedAnalisisCausalAC.ID_TIPO_CAUSA_BASICA,
                            label: selectedAnalisisCausalAC.TIPO_CAUSA_BASICA,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <p>{selectedAnalisisCausalAC?.TIPO_CAUSA_BASICA}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <Col xs="12" md="6" lg="4" className="pe-0">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Factores Personales o del Trabajo:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboFP.map((vcc) => ({
                      value: vcc.ID as string,
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_FACTORES_PERSONALES")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: SingleValue<IComboboxOption>) => {
                      setvalComboFP(e || null);
                      fillComboDC(e?.value as string);
                    }}
                    defaultValue={
                      selectedAnalisisCausalAC
                        ? {
                            value: selectedAnalisisCausalAC.ID_FACTORES_PERSONALES,
                            label: selectedAnalisisCausalAC.FACTORES_PERSONALES,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <p>{selectedAnalisisCausalAC?.FACTORES_PERSONALES}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Descripción de la Causa:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboDC.map((vcc) => ({
                      value: vcc.ID,
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_CAPACIDADES")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: any) => {
                      setvalComboDC(e || "");
                    }}
                    defaultValue={
                      selectedAnalisisCausalAC
                        ? {
                            value: selectedAnalisisCausalAC.ID_CAPACIDADES,
                            label: selectedAnalisisCausalAC.CAPACIDADES,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <p>{selectedAnalisisCausalAC?.CAPACIDADES}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Acción:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <span>
                    <textarea
                      ref={refTxtAccion}
                      className={`form-control form-control-sm ${error("ACCION")} borderGris`}
                      onChange={(e) => {
                        setLenAccion(e.target.value.length);
                      }}
                      defaultValue={selectedAnalisisCausalAC?.ACCION}
                      maxLength={1000}></textarea>
                    <span>{lenAccion}/1000</span>
                  </span>
                ) : (
                  <p>{selectedAnalisisCausalAC?.ACCION}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Responsable:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm == E_EstadoFormCausaDesviacion.Agregar ? (
                  <UserPicker
                    name={"detectadoPor"}
                    callback={(id, value) => {
                      setValResponsable(value?.shift() || null);
                    }}
                    id={"detectadoPor"}
                    key={"1"}
                    multi={false}
                    disabled={false}
                    className={`${error("RESPONSABLE")} borderColorGris`}
                    defaultValue={
                      selectedAnalisisCausalAC
                        ? {
                            mail: selectedAnalisisCausalAC.RESPONSABLE,
                            name: selectedAnalisisCausalAC.RESPONSABLE_DISPLAY,
                          }
                        : null
                    }
                  />
                ) : (
                  <p>{selectedAnalisisCausalAC?.RESPONSABLE_DISPLAY}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <Col xs="12" md="6" lg="4">
                <label>Fecha de asignación:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <p>{moment(selectedAnalisisCausalAC ? selectedAnalisisCausalAC.FECHA_ASIGNACION : new Date()).format(dateFormatDiplay)}</p>
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput ">
              <Col xs="12" md="6" lg="4">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Fecha hasta:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Form.Control
                    ref={refTxtFechaHasta}
                    onChange={(e) => {}}
                    type="date"
                    defaultValue={selectedAnalisisCausalAC ? moment(selectedAnalisisCausalAC?.FECHA_HASTA).format(dateFormatInputReference) : ""}
                    className={`${error("FECHA_HASTA")} borderColorGris`}
                  />
                ) : (
                  <p>{moment(selectedAnalisisCausalAC?.FECHA_HASTA).format(dateFormatDiplay)}</p>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        {isVistaDetallada && (
          <React.Fragment>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Fecha Acción Realizada:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <span>
                      {selectedAnalisisCausalAC?.FECHA_ACCION_REALIZADA
                        ? moment(selectedAnalisisCausalAC?.FECHA_ACCION_REALIZADA).format(dateFormatDiplay)
                        : ""}
                    </span>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Fecha Ingreso Acción Realizada:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <span>
                      {selectedAnalisisCausalAC?.FECHA_INGRESO_ACCION_REALIZADA
                        ? moment(selectedAnalisisCausalAC?.FECHA_INGRESO_ACCION_REALIZADA).format(dateFormatDiplay)
                        : ""}
                    </span>
                  </Col>
                </div>
              </Col>
            </Row>
            {selectedAnalisisCausalAC?.ID_ESTADO === E_EstadoCausa.Rechazada && (
              <React.Fragment>
                <Row>
                  <Col>
                    <div className="row mb-2 ajusteInput">
                      <Col xs="12" md="6" lg="4">
                        <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                        <label>Motivo Rechazo:</label>
                      </Col>
                      <Col xs="12" md="6" lg="8">
                        <label>{selectedAnalisisCausalAC?.MOTIVO_RECHAZO}</label>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
            {selectedAnalisisCausalAC?.ID_ESTADO === E_EstadoCausa.CerradoObservacion && (
              <React.Fragment>
                <Row>
                  <Col>
                    <div className="row mb-2 ajusteInput">
                      <Col xs="12" md="6" lg="4">
                        <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                        <label>Observación:</label>
                      </Col>
                      <Col xs="12" md="6" lg="8">
                        <label>{selectedAnalisisCausalAC?.OBSERVACIONES}</label>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <span className="textSeccion">Carga Documentos Adjuntos:</span>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <AdminListaPagination
                  defaultSortBy="ID"
                  sortDirection="DESC"
                  totalPages={totalPagesListDocumentos}
                  callback={async (pagination) => {
                    await handleCargarDocumentos(pagination);
                  }}
                  reload={async () => {
                    await handleCargarDocumentos();
                  }}
                  columnsDef={columnsDefDocumentos}
                  data={listDocumentos || []}
                  hideAdd={true}
                  hideExport={true}
                  hideReload={true}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
        <Row className="mb-2 ajusteInput mt-4">
          <Col xs="4" md="4" lg={estadoForm === E_EstadoFormCausaDesviacion.Cerrar ? "2" : "4"}></Col>
          {isSendingData ? (
            <Loading />
          ) : (
            <Col xs="4" md="4" lg={estadoForm === E_EstadoFormCausaDesviacion.Cerrar ? "8" : "4"} className="text-center">
              {estadoForm === E_EstadoFormCausaDesviacion.Lectura || (
                <span>
                  {estadoForm === E_EstadoFormCausaDesviacion.Agregar && (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarCausaBasica();
                      }}
                      disabled={isSendingData}>
                      Guardar
                    </button>
                  )}
                  {estadoForm === E_EstadoFormCausaDesviacion.Cerrar && renderEstadoForm() ? (
                    <span>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausa(E_EstadoCausa.Cerrado);
                        }}
                        disabled={isSendingData}>
                        Cerrar
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausa(E_EstadoCausa.CerradoObservacion);
                        }}
                        disabled={isSendingData}>
                        Cerrar con Observaciones
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausa(E_EstadoCausa.Rechazada);
                        }}
                        hidden={selectedAnalisisCausalAC?.MOTIVO_RECHAZO !== null}
                        disabled={isSendingData}>
                        Rechazar
                      </button>
                    </span>
                  ) : (
                    ""
                  )}
                </span>
              )}
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  onClose();
                }}
                disabled={isSendingData}>
                Volver
              </button>
            </Col>
          )}
          <Col xs="4" md="4" lg={estadoForm === E_EstadoFormCausaDesviacion.Cerrar ? "2" : "4"}></Col>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
